import * as Schema from "effect/Schema";
import { freezeMetadata, ValidationError } from "@linempo/kernel";
import { decodeProject } from "@linempo/project-domain";
import { ExportSettings, MAX_EXPORT_DURATION_MS, RenderError, WorkerError } from "@linempo/render-domain";
export const idleJob = () => ({ status: "idle", jobId: null, progress: null, error: null });
export const initialClientState = () => ({
    generate: { ...idleJob(), animationId: "", result: null },
    prepare: { ...idleJob(), plan: null }, export: { ...idleJob(), artifact: null },
    preview: { requestedTimeMs: 0, frame: null, seeking: false }, workspace: { pending: 0, importing: false }, error: null,
});
export const workerError = (reason, message) => new WorkerError({ reason, message });
export function asRenderError(error) {
    if (Schema.is(RenderError)(error))
        return error;
    return workerError("protocol", error instanceof Error ? error.message : String(error));
}
export function checkedProject(input) {
    try {
        const project = decodeProject(input);
        if (project.durationMs > MAX_EXPORT_DURATION_MS)
            throw new RangeError("工程最长为 600000 毫秒");
        return project;
    }
    catch (error) {
        throw new ValidationError({ path: "project", message: error instanceof Error ? error.message : String(error) });
    }
}
export function checkedSettings(input) {
    try {
        return freezeMetadata(Schema.decodeUnknownSync(ExportSettings)(input));
    }
    catch (error) {
        throw new ValidationError({ path: "exportSettings", message: String(error) });
    }
}
